import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cancel-form" }
const _hoisted_2 = { class: "cancel-form__group--submit" }

import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import BasePopup from '@/components/ui/BasePopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DisablePopup',
  props: {
    disableIntegration: { type: Function },
    integrationName: {},
    afterDisableCallback: {}
  },
  emits: ["updateEnabled"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit
const wait = useWait()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

async function disable(): Promise<void> {
  wait.start('Disabling')
  await props.disableIntegration()
  if (props.afterDisableCallback) {
    await props.afterDisableCallback()
  }
  wait.end('Disabling')
  emit('updateEnabled', false)
  hide()
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "Disable the integration?",
    class: "popup--simple"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, " Are you sure you want to disable the " + _toDisplayString(__props.integrationName) + " integration? ", 1),
        _createElementVNode("form", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", {
              class: "cancel-form__close-btn btns btns--largest btns--font-large btns--full",
              onClick: hide
            }, "No"),
            _withDirectives((_openBlock(), _createElementBlock("a", {
              class: "cancel-form__btn btns btns--largest btns--font-large btns--white btns--full",
              onClick: disable
            }, [
              _createVNode(_component_v_wait, { for: "Disabling" }, {
                waiting: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createTextVNode(" Disabling ", -1)),
                  _createVNode(ButtonSpinner)
                ]),
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "Disable", -1))
                ]),
                _: 1
              })
            ])), [
              [_directive_wait, 'Canceling', "disabled"]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})